import React from "react";
import "../StoragePages.scss";
import { Page } from "components/core/Page";
import { StorageHeader } from "components/storages/Header";
import {
	BorderLine,
	Description,
	Heading,
	LastSearchBar,
	ListPoint,
	SubHeading
} from "components/storages/Common";
import { CHEAP_STORAGE_DATA } from "components/storages/ContentData/CheapStorageData";
import Container from "components/core/Page/Container";
import { ScrollToTop } from "components/core/ScrollToTop";
import { PAGE_SUB_TYPES } from "@sparefoot/tracking-events";
import usePageViewTracking from "hooks/tracking/usePageViewTracking";

function CheapStoragePage() {
	usePageViewTracking(PAGE_SUB_TYPES.CHEAP_STORAGE_PRICES_LANDING);

	return (
		<Page
			className="storage-page"
			pageType={PAGE_SUB_TYPES.CHEAP_STORAGE_PRICES_LANDING}
			title="Find Cheap Storage Units Near You | Storage.com"
			description="Find the best deals on cheap self storage units near you by 
			comparing real-time availability, sizes, and amenities before you 
			reserve."
		>
			<Container>
				<StorageHeader
					heading="Find Cheap Storage Near You!"
					searchIn="cheap"
				/>
				<div className="all-sections">
					{CHEAP_STORAGE_DATA?.map((item, index) => (
						<>
							<Heading content={item.heading} />
							<Description desc={item.description} />
							{item.description2 && (
								<Description desc={item.description2} />
							)}
							{item.subHeadings &&
								item.subHeadings.map((subHeading) => (
									<>
										<SubHeading title={subHeading.title} />

										{subHeading.descLink ? (
											<Description
												descLink={subHeading.descLink}
											/>
										) : (
											<Description
												desc={subHeading.desc}
											/>
										)}
									</>
								))}
							<ul>
								{item.points &&
									item.points.map((point) => (
										<ListPoint
											title={point.title}
											desc={point.desc}
											bulletPoints={false}
										/>
									))}
							</ul>
							{index !== CHEAP_STORAGE_DATA.length - 1 && (
								<BorderLine />
							)}
						</>
					))}
					<LastSearchBar />
				</div>
			</Container>
			<ScrollToTop />
		</Page>
	);
}

export default CheapStoragePage;
